export default __webpack_public_path__ + "static/media/chat.1f7427fa.svg";